import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MeiliSearch } from 'meilisearch';
import { environment } from 'src/environments/environment';
import {
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { debounceTime, switchMap } from 'rxjs';
import { UtilService } from 'src/app/shared/services';

const STATIC_OPTIONS = {
  disease: [
    {
      name: 'Medical condition not in the list',
      id: environment.algolia.disease.not_listed,
    },
  ],
  hospital: [
    {
      full_name: 'Hospital not in the list',
      id: environment.algolia.hospital.not_listed,
      type: 'notListed',
    },
    // {
    //   full_name: 'Not admitted to any hospital',
    //   id: environment.algolia.hospital.not_admitted,
    //   type: 'notAdmitted'
    // },
    // {
    //   full_name: 'Does not require hospitalisation',
    //   id: environment.algolia.hospital.not_admitted,
    //   type: 'noHospitalisationRequired'
    // }
  ],
};

@Component({
  selector: 'app-meilisearch-input',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    FormsModule,
    MatAutocompleteModule,
  ],
  templateUrl: './meilisearch-input.component.html',
  styleUrls: ['./meilisearch-input.component.scss'],
})
export class MeilisearchInputComponent {
  private readonly util = inject(UtilService);

  @Input() formGroup: FormGroup;
  @Input() control: FormControl;
  @Input() controlKey: string = '';
  @Input() theme: string = 'safTheme';
  @Input() placeholder: string = 'Search';
  @Input() type: 'hospital' | 'disease' = 'disease';
  @Input() hideIcon: boolean = false;
  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  client = new MeiliSearch({
    host: environment.meilisearch.host,
    apiKey: environment.meilisearch.key,
  });

  searchControl: FormControl = new FormControl('');
  searchResults: any[] = [];
  staticOptions: any[] = [];
  showStatic = false;
  selected = '';
  isLoading = false;

  ngOnInit() {
    this.staticOptions = STATIC_OPTIONS[this.type];
    this.searchControl.valueChanges
      .pipe(
        debounceTime(300),
        switchMap((value) => {
          if (typeof value === 'string' && value.trim().length) {
            this.isLoading = true;
            return this.search(value);
          }
          this.showStatic = false;
          return [];
        })
      )
      .subscribe((res) => {
        this.showStatic = true;
        this.searchResults = res?.hits || [];
        this.isLoading = false;
        if (typeof this.searchControl.value !== 'object') {
          this.searchControl.setErrors({ notFromList: true });
        }
      });
  }

  ngAfterViewInit() {
    const preValue = this.control?.value;
    if (preValue) {
      this.searchControl.setValue(preValue);
      this.selected = preValue?.full_name || preValue?.name;
      this.searchControl.disable();
    }
  }

  search(query: string) {
    return this.client
      .index(environment.meilisearch[this.type].index)
      .search(query);
  }

  displayFn(item: any): string {
    return item?.name || item?.full_name || '';
  }

  selectOption(option: any) {
    this.selected = option?.full_name || option?.name;
    this.searchControl.disable();
    this.onSelect.emit(option);
  }

  onBlur() {
    this.control.markAllAsTouched();
  }

  clear() {
    this.selected = '';
    this.searchControl.enable();
    this.searchControl.setValue('');
    this.onSelect.emit('');
    setTimeout(() => {
      this.util.doc.getElementById(`input-${this.controlKey}`)?.focus()
    }, 10);
  }
}
